// extracted by mini-css-extract-plugin
export default {"imageUpload":"UserDetails_imageUpload__P2Ody","topContainerStyle":"UserDetails_topContainerStyle__XidS+","mainHeading":"UserDetails_mainHeading__F53a2"};